import { cn as X } from "../../../lib/shadcn/utils/utils.js";
import { FormsKeys as mt } from "../../../i18n/translations/types/forms.js";
import { Namespace as ot } from "../../../i18n/translations/types/namespaces.js";
import { FloatingInput as ft, FloatingLabel as it } from "../../../lib/shadcn/ui/components/floating-input.js";
import { cleanInput as F, mapInputModeToStandard as ct } from "../../../helpers/input.helper.js";
import { applyInputMasks as h } from "../../../helpers/input-masks.helper.js";
import { handleValidation as y } from "../../../helpers/validation.helper.js";
import { useCallback as T, useEffect as P, useMemo as Y, useRef as rt, useState as Z } from "react";
import { jsx as j, jsxs as B } from "react/jsx-runtime";
import { IDS as et } from "@my-medication/e2e-page-objects/selectors";
import { useTranslation as C } from "react-i18next";
import { v4 as pt } from "uuid";
var at = ({ className: I, label: k, startIcon: w, interactiveIcon: V, endIcon: b, id: D, name: n, invalid: G, errorMessage: f, required: o, highlight: K, disabled: d, defaultValue: R, value: a, hint: _, masks: c = [(S) => S], inputMode: r, hideOptionalLabel: z, namespaces: q, resetTrigger: A, validator: x, validateTrigger: J, onValidateResult: L, onValueChange: u, onBlur: g, onFocus: E, disableInternalValidation: i, controlledMode: H = !1, ...O }) => {
  const { t: S } = C(q), { t: v } = C(ot.Forms), Q = rt(n || `textField-${pt()}`), [N, e] = Z(f ? { message: f } : void 0), [p, $] = Z(void 0);
  P(() => {
    e(f ? { message: f } : void 0);
  }, [f]), P(() => {
    const s = `${a || R || ""}`;
    if (p === void 0 && s || A) {
      const t = h(s, [(m) => F(r, m), ...c], "initial");
      if ($(t), s && !i) {
        const { isValid: m, error: l } = y({
          t: v,
          validator: x,
          value: t,
          extraProps: { required: o }
        });
        e(m ? void 0 : { message: l });
      }
    }
  }, [
    p,
    a,
    R,
    o,
    A,
    i
  ]), P(() => {
    if (J && !i) {
      const s = y({
        t: v,
        validator: x,
        value: p || "",
        extraProps: { required: o }
      });
      e(s.isValid ? void 0 : { message: s.error }), L && L(s.isValid);
    }
  }, [J, i]);
  const U = Y(() => o || z ? "" : ` (${v(mt.General_Optional)})`, [
    o,
    z,
    v
  ]), W = Y(() => d ? "disabled" : N || f || G ? "invalid" : K ? "highlight" : "default", [
    N,
    f,
    G,
    K,
    d
  ]), M = T((s) => {
    const t = h(`${s?.target?.value || ""}`, [(m) => F(r, m), ...c], "change");
    if ($(t), !i) {
      const { isValid: m, error: l } = y({
        t: v,
        validator: x,
        value: t,
        extraProps: { required: o }
      });
      e(m ? void 0 : { message: l });
    }
    u && u(t);
  }, [
    x,
    u,
    e,
    c,
    o,
    i
  ]), tt = T((s) => {
    const t = h(`${s?.target?.value || ""}`, [(m) => F(r, m), ...c], "blur");
    $(t), g && g(t);
  }, [g]);
  P(() => {
    if (!(a === "" && u && !H) && H && a !== void 0 && p !== void 0) {
      const s = `${a}`, t = h(s, [(m) => F(r, m), ...c], "initial");
      if (t !== p && ($(t), !i))
        if (t === "") e(void 0);
        else {
          const { isValid: m, error: l } = y({
            t: v,
            validator: x,
            value: t,
            extraProps: { required: o }
          });
          e(m ? void 0 : { message: l });
        }
    }
  }, [
    a,
    r,
    c,
    i,
    o,
    x,
    u,
    p,
    H
  ]);
  const st = T((s) => {
    const t = h(`${s?.target?.value || ""}`, [(m) => F(r, m), ...c], "focus");
    $(t), E && E(t);
  }, [E]);
  return /* @__PURE__ */ B("div", {
    className: X("flex w-full flex-col gap-0", I),
    "data-testid": `textfield-${n}`,
    children: [
      /* @__PURE__ */ j(ft, {
        ...O,
        id: D || Q.current,
        name: `${n}${U}`,
        "data-qa-ta": `input-${n}`,
        disabled: d,
        inputMode: ct(r),
        startIcon: w,
        interactiveIcon: V,
        endIcon: b,
        required: !i && o,
        value: p || "",
        variant: W,
        onChange: M,
        onBlur: tt,
        onFocus: st,
        children: k && /* @__PURE__ */ B(it, {
          htmlFor: D || Q.current,
          variant: W,
          iconPosition: w ? "start" : "default",
          className: X(`${O.placeholder || ""}`.trim().length > 0 ? "top-5.5! -translate-y-4! scale-100! text-sm!" : void 0),
          children: [k, U]
        })
      }),
      (f || N?.message) && /* @__PURE__ */ j("span", {
        className: "mt-1 px-2 text-sm text-error-700",
        "data-testid": et.textFieldError(n),
        children: S(f || N?.message || "")
      }),
      _ && /* @__PURE__ */ j("span", {
        className: "mt-1 px-2 text-sm text-secondary-600",
        children: _
      })
    ]
  });
};
at.displayName = "TextField";
export {
  at as TextField
};

//# sourceMappingURL=TextField.js.map